import React from "react"
import PropTypes from "prop-types"

const Video = ({ video }) => {
  return (
    <div className="video container container--wide islet">
      <div className="island text-center">
        <h2>{video.videoTitle}</h2>
        {video.videoDescription &&
          <div className="container container--narrow">
            <p className="landmarkless" dangerouslySetInnerHTML={{__html: video.videoDescription}} />
          </div>
        }
      </div>
      <div className="responsive-embed">
        <iframe title="youtube" src={'https://www.youtube.com/embed/' + video.youTubeVideoID + '?rel=0&modestbranding=1'} frameBorder='0' allowFullScreen></iframe>
      </div>
    </div>
  )
}

Video.propTypes = {
  video: PropTypes.object.isRequired,
}

export default Video
